(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/redeem/components/single-ticket.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/redeem/components/single-ticket.js');
"use strict";

const Image = svs.content.image_v2.Image;
const _React = React,
  useEffect = _React.useEffect;
const _svs$ticket_gifts$uti = svs.ticket_gifts.utils.campaign.ids,
  _svs$ticket_gifts$uti2 = _svs$ticket_gifts$uti === void 0 ? {} : _svs$ticket_gifts$uti,
  LYCKOPLATSEN = _svs$ticket_gifts$uti2.LYCKOPLATSEN;
const SingleTicket = _ref => {
  let campaign = _ref.campaign,
    history = _ref.history,
    _ref$voucher = _ref.voucher,
    voucher = _ref$voucher === void 0 ? {} : _ref$voucher,
    message = _ref.message,
    toName = _ref.toName,
    closed = _ref.closed,
    personalGreeting = _ref.personalGreeting,
    _ref$receiverSameAsBu = _ref.receiverSameAsBuyer,
    receiverSameAsBuyer = _ref$receiverSameAsBu === void 0 ? 0 : _ref$receiverSameAsBu;
  const BubbleInfo = svs.tur.bubbleInfo.components.BubbleInfo;
  const reactPayfooterCustomerServiceTexts = svs.ticket_gifts.constants.reactPayfooterCustomerServiceTexts;
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const defaultImgSrc = "".concat(svs.core.config.data.svsconfig.cdn, "/images/ticket-gifts/SvS-Tur-presentpaket-mockup.png");
  const bubbleInfoHeader = svs.ticket_gifts.functions.bubbleInfoHeader;
  const img = voucher.img;
  let tgClassName = '';
  if (campaign === LYCKOPLATSEN) {
    tgClassName = 'tg-container-center';
  }
  const handlePlayClick = e => {
    var _svs$ticket_gifts$cho, _svs$ticket_gifts$gam;
    const gameCode = ((_svs$ticket_gifts$cho = svs.ticket_gifts.chooseGameForVoucher(voucher)) === null || _svs$ticket_gifts$cho === void 0 ? void 0 : _svs$ticket_gifts$cho.type) || ((_svs$ticket_gifts$gam = svs.ticket_gifts.games) === null || _svs$ticket_gifts$gam === void 0 || (_svs$ticket_gifts$gam = _svs$ticket_gifts$gam.find(game => game.voucherId === voucher.voucherConfigId)) === null || _svs$ticket_gifts$gam === void 0 ? void 0 : _svs$ticket_gifts$gam.type);
    if (gameCode) {
      svs.ticketgames.ticketUtility.utils.tracking.trackScratchTicket(gameCode, 1);
    }
    if (voucher.availableOnline) {
      e && e.preventDefault();
      history && history.push("".concat(history.location.pathname, "/spela/").concat(voucher.giftCode));
    } else {
      var _svs$ticket_gifts$gam2;
      const type = (_svs$ticket_gifts$gam2 = svs.ticket_gifts.games) === null || _svs$ticket_gifts$gam2 === void 0 || (_svs$ticket_gifts$gam2 = _svs$ticket_gifts$gam2.find(game => game.voucherId === voucher.voucherConfigId)) === null || _svs$ticket_gifts$gam2 === void 0 ? void 0 : _svs$ticket_gifts$gam2.type;
      svs.ticket_gifts.redeem.components.util.showNotAvailableDialog(type, () => history && history.push("../../".concat(voucher.giftCode, "/streckkod")));
    }
  };

  useEffect(() => {
    return () => svs.ticket_gifts.redeem.components.util.hideNotAvailableDialog();
  }, []);
  const payfooterButtons = [{
    primary: true,
    text: receiverSameAsBuyer ? 'Skrapa lott' : 'Skrapa presentlott',
    onClick: handlePlayClick,
    disabled: closed
  }];
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "tg-container ".concat(tgClassName),
    "data-testid": "single-ticket"
  }, receiverSameAsBuyer ? React.createElement("div", {
    className: "u-flex u-flex-justify-content-center padding-top-2 f-body"
  }, React.createElement("h1", {
    className: "h1 align-center single-ticket-heading-max-width"
  }, "1 lott till ett v\xE4rde av ", svs.utils.format.Currency(voucher.ticketPrice), " kr")) : React.createElement("div", {
    className: "single-ticket-bubble-wrapper"
  }, React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: bubbleInfoHeader(personalGreeting, toName)
  }, message)), React.createElement("div", {
    className: "single-ticket-img-wrapper ".concat(campaign ? "campaign-".concat(campaign) : '')
  }, img && typeof img === 'object' && React.createElement(Image, {
    cssSelectors: "single-ticket-img",
    image: img
  }), img && typeof img === 'string' && React.createElement("img", {
    alt: voucher.name,
    src: img
  }), !img && React.createElement("img", {
    alt: "Presentpaket",
    className: "padding-2",
    src: defaultImgSrc
  }))), React.createElement(Payfooter, {
    buttons: payfooterButtons,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.redeem.components.SingleTicket', SingleTicket);

 })(window);